export const encodedText = (text) => {
  return window.btoa(text)
}

export const decodeText = (text) => {
  return window.atob(text)
}